import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { name: '首页', path: '/', icon: 'ri-home-4-line' },
  { name: '分类导航', path: '/category/yingshi', icon: 'ri-apps-line' },
  { name: '吃瓜爆料', path: '/article/chigua-2026-0706', icon: 'ri-fire-line' },
  { name: '关于我们', path: '/about', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 group cursor-pointer">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-background-50 font-heading font-bold text-lg">51</span>
            </div>
            <span className={`font-heading font-bold text-lg transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-foreground-900'
            }`}>
              51网址导航
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`relative px-4 py-2 text-sm font-label font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(item.path)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl text-foreground-800`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-150 cursor-pointer ${
                  isActive(item.path)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}